export function setLocalStorage(key: string, value: any): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    if (value && key) {
      if (typeof value === 'object') {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, value);
      }
    } else {
      console.error('Key and value are required');
    }
  } else {
    console.error('localStorage is not available');
  }
}
